import {Inject, Pipe, PipeTransform} from '@angular/core';
import {TranslateService} from "@ngx-translate/core";

@Pipe({
  standalone: false,
  name: 'planningPackagesPalletsPipe'
})
export class PlanningPackagesPalletsPipe implements PipeTransform {

  constructor(@Inject(TranslateService) private translateService: TranslateService) {}

  transform(orderPackagesRef, enableSuffix?): unknown {

    let sum;

    if (orderPackagesRef) {
      sum = orderPackagesRef.reduce((acc, item) => {
        if (item.pallets) {
          acc += item.pallets;
          // acc += (item.pallets * (item.count || 1));
        }
        return acc;
      }, 0);
    }

    let decimalNumber = Number.isSafeInteger(sum) ? 0 : 2;

    return enableSuffix ? this.translateService.instant(sum == 1 ? 'X_PALLET' : 'X_PALLETS', {sum: sum.toFixed(decimalNumber)}) : sum.toFixed(decimalNumber);
  }

}
